import React, { forwardRef } from "react";
import { Badge, badgeClasses, styled } from "@mui/material";
import Tooltip from "@hyro-components/Tooltip";
import BellIcon from "src/icons/BellIcon";
import { StyledIconButton } from "src/layout/Header/HeaderStyles";
import { useNotificationsV2 } from "src/queries/hooks/assistants";
import useAppStore from "src/stores/appStore";
import { assistantIdSelector, selectedAccountIdSelector } from "src/stores/selectors/appSelectors";
import { useFlags } from "launchdarkly-react-client-sdk";

const NotificationButton = forwardRef(({ onClick, enableNotificationsSocketProp }, ref) => {
  const accountId = useAppStore(selectedAccountIdSelector);
  const assistantId = useAppStore(assistantIdSelector);
  const { enableNotificationsSocket } = useFlags();
  const isSocketEnabled = enableNotificationsSocketProp || enableNotificationsSocket;
  const { notificationsCount: notificationsCountFromSocket } = useAppStore();
  const { data } = useNotificationsV2({ accountId, assistantId }, { enabled: !isSocketEnabled });
  const notificationsCountFromApi = data?.pages[0]?.badgeCounter || 0;
  const unreadNotificationsCount = isSocketEnabled ? notificationsCountFromSocket : notificationsCountFromApi;

  const handleClick = (e) => {
    if (onClick) onClick(e);
  };

  return (
    <Tooltip title="Notifications">
      <StyledIconButton
        data-testid="notifications-button"
        onClick={handleClick}
        ref={ref}
      >
        <StyledBadge
          overlap="circular"
          color="primary"
          badgeContent={unreadNotificationsCount}
          invisible={!unreadNotificationsCount}
          data-testid="notifications-badge"
        >
          <BellIcon />
        </StyledBadge>
      </StyledIconButton>
    </Tooltip>
  );
});

const StyledBadge = styled(Badge)({
  fontSize: 11,
  [`.${badgeClasses.badge}`]: {
    minWidth: 18,
    height: 18
  }
});

NotificationButton.displayName = "NotificationButton";

export default NotificationButton;
